/*
 * The form is grouped into labelled field sets rather than one long stack of
 * full-width inputs: related fields (beds/baths, rent/sqft) sit side by side so
 * the whole record is scannable without scrolling.
 */

.form {
    display: flex;
    flex-direction: column;
    row-gap: 18px;
}

.group {
    border: 1px solid rgba(17, 24, 39, 0.09);
    border-radius: 10px;
    padding: 12px 16px 16px;
    margin: 0;
    display: flex;
    flex-direction: column;
    row-gap: 14px;
    background-color: #fff;
}

.groupLegend {
    display: flex;
    align-items: center;
    column-gap: 7px;
    padding: 0 6px;
    font-family: Outfit, sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: #75736c;
}

.groupIcon {
    display: flex;
    color: #10b981;
}

.grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.gridFull {
    grid-column: 1 / -1;
}

/* the vacancy switch reads as a status control, so it gets a tinted strip */
.statusRow {
    display: flex;
    align-items: center;
    column-gap: 16px;
    row-gap: 10px;
    flex-wrap: wrap;
    padding: 10px 12px;
    border-radius: 8px;
    background-color: #fbfcf6;
    border: 1px solid rgba(17, 24, 39, 0.06);
}

.statusToggle {
    flex: 0 0 auto;
    margin-right: 0;
    margin-left: 0;
}

.statusDate {
    flex: 1 1 220px;
    min-width: 0;
}

.parentRow {
    display: flex;
    align-items: flex-start;
    column-gap: 12px;
}

.parentField {
    flex: 1;
    min-width: 0;
}

.parentFillButton {
    flex-shrink: 0;
    height: 40px;
    white-space: nowrap;
}

/* a read-back of the entered address, so a mistyped one is obvious before saving */
.addressPreview {
    font-size: 12.5px;
    color: #75736c;
    padding: 8px 10px;
    border-radius: 6px;
    background-color: #fbfcf6;
    border: 1px dashed rgba(17, 24, 39, 0.12);
    line-height: 1.45;
}

.hint {
    font-size: 12px;
    color: #75736c;
    line-height: 1.4;
}

@media (max-width: 768px) {
    .grid {
        grid-template-columns: minmax(0, 1fr);
    }

    .parentRow {
        flex-direction: column;
        row-gap: 10px;
    }

    .parentFillButton {
        width: 100%;
    }
}

.shrinkable {
    min-width: 0;
}

.parentOptionText {
    min-width: 0;
    flex: 1;
}

.toggleControl {
    margin-left: 0;
    margin-right: 0;
}
